import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

/**
 * GraficaBarras — Barras verticales centradas y responsivas.
 *
 * Props:
 *   titulo   {string}   Título opcional sobre la gráfica
 *   etiquetas {string[]} Etiquetas del eje X
 *   datos     {Array<{ label: string, valores: number[] }>}
 *   colores   {string[]} Colores de cada dataset
 */
const GraficaBarras = ({ titulo = "", etiquetas = [], datos = [], colores = [] }) => {
    const data = {
        labels: etiquetas,
        datasets: datos.map((item, index) => ({
            label: item.label,
            data: item.valores,
            backgroundColor: colores[index % colores.length],
            borderRadius: 6,
            barPercentage: 0.65,
            categoryPercentage: 0.7,
        })),
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "top",
                labels: { font: { size: 12, weight: "bold" }, padding: 12 },
            },
            tooltip: {
                callbacks: {
                    label: (item) => ` ${item.dataset.label}: ${item.raw}`,
                },
            },
            datalabels: {
                display: true,
                color: "#fff",
                textStrokeColor: "rgba(0,0,0,0.55)",
                textStrokeWidth: 2,
                anchor: "center",
                align: "center",
                font: { weight: "bold", size: 11 },
                formatter: (value) => (value !== 0 ? Math.round(value) : ""),
                clip: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: { font: { size: 12 }, stepSize: 1 },
                grid: { color: "rgba(0,0,0,0.06)" },
            },
            x: {
                ticks: {
                    font: { size: 11, weight: "bold" },
                    autoSkip: false,
                    maxRotation: 40,
                    minRotation: 20,
                },
                grid: { display: false },
            },
        },
        layout: { padding: { top: 8, bottom: 4, left: 4, right: 4 } },
    };

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            {titulo && (
                <h4 style={{ fontWeight: 700, marginBottom: 8, textAlign: "center", fontSize: 13 }}>
                    {titulo}
                </h4>
            )}
            {/* Contenedor ocupa el 100% del padre para ajustarse a cualquier GraficaCard */}
            <div style={{ width: "100%", height: "100%", minHeight: 220 }}>
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default GraficaBarras;